import type { PhoneCallFields, PhoneCallStyle } from '../types';

/** Default phoneCall presentation is the inline overlay card. */
export function resolvePhoneCallStyle(
  fields: Pick<PhoneCallFields, 'style'>
): PhoneCallStyle {
  return fields.style === 'phone' ? 'phone' : 'inline_call';
}

export function isInlinePhoneCallStyle(
  fields: Pick<PhoneCallFields, 'style'>
): boolean {
  return resolvePhoneCallStyle(fields) === 'inline_call';
}
